import { Tabs, Tab, Box, Theme } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { FormikProps } from "formik"
import { HourReportFormState } from "../../schemas"
import { useTranslation } from "react-i18next"

export const MethodSelectorTabs = ({ formik }: Props) => {
  const { t } = useTranslation("hour-report")
  const methodOptions: { label: string; value: HourReportFormState["method"] }[] = [
    { label: t("form.manual", { defaultValue: "Hours" }), value: "manual" },
    { label: t("form.times", { defaultValue: "Times" }), value: "interval" },
    { label: t("form.timer", { defaultValue: "Timer" }), value: "timer" },
  ]
  const classes = useStyles()
  const { values, setFieldValue } = formik

  const selectedIndex = methodOptions.findIndex((opt) => opt.value === values.method)

  const handleChange = (_: React.ChangeEvent<{}>, newIndex: number) => {
    setFieldValue("method", methodOptions[newIndex].value)
  }

  return (
    <Box mt={3}>
      <Tabs
        value={selectedIndex}
        onChange={handleChange}
        classes={{
          root: classes.root,
          indicator: classes.indicator,
        }}
      >
        {methodOptions.map((option) => (
          <Tab
            key={option.value}
            label={option.label}
            classes={{
              root: classes.tabRoot,
              selected: classes.selected,
            }}
          />
        ))}
      </Tabs>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.divider,
    borderRadius: 18,
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0.5),
    maxHeight: 36,
    minHeight: 36,
  },
  tabRoot: {
    borderRadius: 18,
    minHeight: 28,
    maxHeight: 28,
    minWidth: "undet",
    width: "auto",
    flex: 1,
  },
  selected: {
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    display: "none",
  },
}))

type Props = {
  formik: FormikProps<HourReportFormState>
}
